import { useEffect, useContext } from "react";
import { Context } from "Context";
import lottie from "lottie-web";

const mainClass = "help-lottie-animation";

const LottieAnimation = ({
	animation,
	id,
	modifier,
	isMainTitlePresent = true,
}) => {
	const { config } = useContext(Context);
	const requiredParametersReceived = config.helpAssetsUrl && animation && id;
	useEffect(() => {
		if (!requiredParametersReceived) return;
		lottie.loadAnimation({
			container: document.querySelector(`#${id}`),
			path: `${config.helpAssetsUrl}/animations/${animation}`,
		});
	}, [requiredParametersReceived, config.helpAssetsUrl, animation, id]);

	if (!requiredParametersReceived) return null;

	return (
		<div
			className={`${mainClass}${modifier ? ` ${mainClass}--${modifier}` : ""}${
				isMainTitlePresent ? "" : ` ${mainClass}--no-header`
			}`}
			id={id}
		></div>
	);
};

export default LottieAnimation;
